import React from "react";
import { Helmet } from "react-helmet";

import Header from "../../components/ui/Header";
import BreadcrumbNavigation from "../../components/ui/BreadcrumbNavigation";

import GlobalSphereBackground from "../../components/3d/GlobalSphereBackground";

import ContactHero from "./components/ContactHero";
import ContactInfo from "./components/ContactInfo";
import ContactForm from "./components/ContactForm";
import ContactMap from "./components/ContactMap";
import ContactEmergency from "./components/ContactEmergency";
import FooterSection from "pages/homepage-with-3d-construction-experience/components/FooterSection";
const ContactQuoteRequest = () => {
  return (
    <>
      <Helmet>
        <title>Contacto y Cotización — SIRECC</title>
        <meta
          name="description"
          content="Solicita la cotización de tu proyecto y recibe asesoría especializada. Obra civil, acabados, sistemas eléctricos, hidrosanitarios y más."
        />
        <link rel="canonical" href="/contact-quote-request" />
      </Helmet>

      {/* Fondo general con esfera global */}
      <div className="min-h-screen relative bg-transparent">
        <GlobalSphereBackground />

        <div
          className="absolute inset-0 pointer-events-none z-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(11,22,32,0.92) 0%, rgba(29,41,70,0.88) 50%, rgba(11,22,32,0.98) 100%)",
          }}
        />

        <div className="relative z-10">
          <Header />

          <main className="relative">
            {/* Migas */}
            <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-6">
              <BreadcrumbNavigation />
            </div>

            {/* Hero */}
            <ContactHero />

            {/* Info + Formulario */}
            <section className="max-w-7xl mx-auto px-6 lg:px-8 mt-8 grid lg:grid-cols-5 gap-8 pb-24">
              <div className="lg:col-span-2">
                <ContactInfo />
              </div>
              <div className="lg:col-span-3">
                <ContactForm />
              </div>
            </section>

            {/* Mapa con Borde */}
            <ContactMap />

            {/* Emergencias 24/7 */}
            <ContactEmergency />

            {/* Footer corporativo */}
            <FooterSection />
          </main>
        </div>
      </div>
    </>
  );
};

export default ContactQuoteRequest;
